import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { getDatabase } from 'firebase/database'
import { getFirestore } from 'firebase/firestore/lite'

const firebaseConfig = {
  apiKey: 'AIzaSyCPJyMyA8N_-m1S4KLyH779X3QAPTDiSvk',
  authDomain: 'shina-general-db.firebaseapp.com',
  projectId: 'shina-general-db',
  storageBucket: 'shina-general-db.appspot.com',
  messagingSenderId: '438755254807',
  appId: '1:438755254807:web:33fcafb59f1e2804df3252',
  /* 
  during setup of realtime database, if you choose another region different from us-central,
  you need to add databaseURL to the firebaseConfig
  */
  databaseURL:
    'https://shina-general-db-default-rtdb.europe-west1.firebasedatabase.app',
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth()
const provider = new GoogleAuthProvider()
/* export const db = async () => {
  return await getDatabase(app)
}; */
export const storage = getStorage(app)

export const db = getDatabase()
export const signInWithGoogle = () => signInWithPopup(auth, provider)
